/* eslint-disable */
export enum Units {
  Reference = 0,
  Metric,
  Imperial
}

export enum ProfileUnits {
  Metric = 0,
  Imperial
}
